export const RESHOW_AJAX_TOOLTIP_SELECTOR = '[data-reshow-ajax-tooltip="true"]'

export function reshowAjaxTooltipSelectorFor(element) {
  if (!element?.dataset?.reshowAjaxTooltipKey) return null

  return `${RESHOW_AJAX_TOOLTIP_SELECTOR}[data-reshow-ajax-tooltip-key="${CSS.escape(
    element.dataset.reshowAjaxTooltipKey
  )}"]`
}

export function tooltipContentFor(element) {
  return element?.getAttribute('aria-label') || element?.getAttribute('title')
}

export function reshowAjaxTooltipFor(
  element,
  {
    root = document,
    retries = 10,
    retryDelay = 30,
    setTimeout: schedule = globalThis.setTimeout,
  } = {}
) {
  const selector = reshowAjaxTooltipSelectorFor(element)
  if (!selector) return false

  const attempt = (remaining) => {
    const replacement = root.querySelector(selector)
    const content = tooltipContentFor(replacement)

    if (replacement && content && replacement._tippy) {
      replacement.dispatchEvent(
        new CustomEvent('updateContent', { detail: { content, show: true } })
      )
      return
    }

    if (remaining > 0) schedule(() => attempt(remaining - 1), retryDelay)
  }

  schedule(() => attempt(retries), retryDelay)
  return true
}
